import { render, staticRenderFns } from "./wallboard.vue?vue&type=template&id=574c4c12"
import script from "./wallboard.vue?vue&type=script&lang=js"
export * from "./wallboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports